import { Client } from "@/Common/Api/Client";
import { Guid } from "@/Common/Models/Guid";
import { Server } from "@/Common/Operations/operations.server";
import { ClientResponse } from "../ClientResponse";
import { IAddPrescriptionPrintHistoryResponse } from "./Dto/AddPrescriptionPrintHistoryResponse";

class PrescriptionPrintHistoryClient {
    public static addPrescriptionPrintHistory(prescriptionId: Guid): Promise<ClientResponse<IAddPrescriptionPrintHistoryResponse>> {
        return Client.postAsync<IAddPrescriptionPrintHistoryResponse>(
            Server.Myle_AddPrescriptionPdfPrintHistory,
            {
                PrescriptionId: prescriptionId
            }
        );
    }
}

export { PrescriptionPrintHistoryClient };
